import { render, staticRenderFns } from "./PublisherSetupTabCounter.vue?vue&type=template&id=402dc2c0"
import script from "./PublisherSetupTabCounter.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports